import React, { useEffect } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Drawer } from "antd";
import "./generateReport.scss";
import ReportForm from "../../../shared/components/ReportForm";
import { AppRoutes } from "../../../routes/routeConstants/appRoutes";
import AuthContainer from "../../../store/container/AuthContainer";
import { AuthReducerProps } from "../../../store/reducers/authReducer";
import ProfileService from "../../../services/Profile/profile.service";
import { UserRoleEnum } from "../../../enums/userRole.enum";
import { setUser } from "../../../store/actions/authActions";
import { Admin } from "../../../models/Admin/admin.model";
import { Doctor } from "../../../models/Doctor/doctor.model";
import { ScanCenter } from "../../../models/ScanCenter/scanCenter.model";

const RETURN_SEARCH_PARAM = "returnSearch";

function getReturnSearch(search: string): string {
  const params = new URLSearchParams(search);
  const encoded = params.get(RETURN_SEARCH_PARAM);
  if (!encoded) return "";
  try {
    return decodeURIComponent(encoded);
  } catch {
    return "";
  }
}

interface ReportProps extends AuthReducerProps {}

function GenerateReportPage({ userRole, user }: ReportProps) {
  const dispatch = useDispatch();
  const { caseId } = useParams<{ caseId: string }>();
  const history = useHistory();
  const location = useLocation();
  const returnSearch = getReturnSearch(location.search);

  const homePath = AppRoutes.HOME + (returnSearch ? `?${returnSearch}` : "");

  // Fetch fresh profile on mount so adminFeatures/doctorFeatures are up-to-date
  // (avoids stale localStorage user when opening fullscreen from listing)
  useEffect(() => {
    if (!user || !userRole || userRole === UserRoleEnum.SCAN_CENTER) return;
    ProfileService.getProfile(
      userRole,
      (profile: Admin | Doctor | ScanCenter) => {
        dispatch(setUser(profile));
      },
      () => {},
      () => {}
    );
  }, []);

  const handlePublish = () => {
    setTimeout(() => {
      window.close();
    }, 500);
  };

  const handleClose = () => {
    setTimeout(() => {
      window.close();
    }, 500);
  };

  if (!caseId) return null;

  return (
    <Drawer
      className="generate-report-page__drawer"
      visible
      width="100%"
      title={null}
      closable={false}
      onClose={handleClose}
      maskClosable={false}
      footer={null}
      keyboard={false}
      destroyOnClose
    >
      {user && userRole && (
        <ReportForm
          caseDetailId={Number(caseId)}
          onPublish={handlePublish}
          isFullScreen={true}
        />
      )}
    </Drawer>
  );
}

export default AuthContainer(GenerateReportPage);
